import { api } from './api';

/** Cheapest in-stock listing for one caliber (powers a data-driven FAQ). */
export interface FaqCaliberDeal {
  caliber: string;
  slug: string;
  pricePerRound: number;
  retailer: string | null;
}

/** Live aggregates behind the FAQ page (`GET /api/faq`, #253). */
export interface FaqData {
  activeRetailers: number;
  inStockListings: number;
  caliberCount: number;
  cheapestByCaliber: FaqCaliberDeal[];
}

/** Fetch the live FAQ aggregates. */
export function getFaq(): Promise<FaqData> {
  return api.get<FaqData>('/faq');
}

export const faqApi = { getFaq };
